import request from "../utils/request.js"

// 获取商品列表
export function getMallListApi(params) {
    return request({
        url: "/mall/list",
        method: "post",
        data: params,
    })
}
// 获取商品列表
export function saveMallApi(params) {
    return request({
        url: "/mall/saveMall",
        method: "post",
        data: params,
    })
}
// 获取商品详情
export function getMallDetailsApi(params) {
    return request({
        url: "/mall/detail/"+params,
        method: "get",
    })
}
// 获取商品类型列表
export function getCommodityTypeApi() {
    return request({
        url: "/mall/getCommodityType",
        method: "get"
    })
}
// 删除商品
export function delCollectApi(id) {
    return request({
        url: "/mall/delCollect/"+id,
        method: "get"
    })
}